import React from "react";
import {
  Box, TextField, Typography, Button, IconButton,
  FormControl, InputLabel, Select, MenuItem
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";

const row = { display: "grid", gridTemplateColumns: "1fr auto", gap: 8, marginBottom: 8 };

const LgpdEditor = ({ value, onChange }) => {
  const v = value || {
    format: "lgpd.v1",
    intro: "",
    controlador: "",
    contatos: [],
    bases_legais: [],
    finalidades: [],
    direitos: [],
    como_exercer_steps: [],
    compartilhamento: "",
    seguranca_retencao: "",
    anpd: "",
    links_refs: {
      privacy: { label: "", href: "", target: "_self" },
      cookies: { label: "", href: "", target: "_self" },
    },
    disclaimer: "",
  };

  const set = (patch) => onChange({ ...v, ...patch });

  const addSimple = (k) => set({ [k]: [...(v[k] || []), ""] });
  const setSimple = (k, i, val) => {
    const arr = [...(v[k] || [])]; arr[i] = val; set({ [k]: arr });
  };
  const remSimple = (k, i) => set({ [k]: (v[k] || []).filter((_, idx) => idx !== i) });

  const addLink = () => set({ contatos: [...(v.contatos || []), { label: "", href: "", target: "_self" }] });
  const setLink = (i, patch) => {
    const links = [...(v.contatos || [])];
    links[i] = { ...(links[i] || {}), ...patch };
    set({ contatos: links });
  };
  const remLink = (i) => set({ contatos: (v.contatos || []).filter((_, idx) => idx !== i) });

  return (
    <Box sx={{ display: "grid", gap: 16 }}>
      <div>
        <Typography variant="subtitle1">LGPD (lgpd.v1)</Typography>
        <TextField
          label="Objetivo / Introdução"
          value={v.intro || ""}
          onChange={(e)=>set({ intro: e.target.value })}
          fullWidth multiline minRows={3} sx={{ mt: 1 }}
        />
      </div>

      <div>
        <Typography variant="subtitle2">Controlador e Encarregado (DPO)</Typography>
        <TextField
          label="Texto"
          value={v.controlador || ""}
          onChange={(e)=>set({ controlador: e.target.value })}
          fullWidth multiline minRows={3} sx={{ mt: 1, mb: 1 }}
        />

        <Typography variant="body2" sx={{ mb: 1 }}>Canais de contato</Typography>
        {(v.contatos || []).map((l, i) => (
          <Box key={`link-${i}`} sx={{ display: "grid", gridTemplateColumns: "2fr 3fr 1fr auto", gap: 8, mb: 1 }}>
            <TextField label="Rótulo" value={l.label || ""} onChange={(e)=>setLink(i,{ label:e.target.value })} />
            <TextField label="URL" value={l.href || ""} onChange={(e)=>setLink(i,{ href:e.target.value })} />
            <FormControl>
              <InputLabel>Target</InputLabel>
              <Select label="Target" value={l.target || "_self"} onChange={(e)=>setLink(i,{ target: e.target.value })}>
                <MenuItem value="_self">_self</MenuItem>
                <MenuItem value="_blank">_blank</MenuItem>
              </Select>
            </FormControl>
            <IconButton onClick={()=>remLink(i)}><DeleteOutlineRoundedIcon /></IconButton>
          </Box>
        ))}
        <Button startIcon={<AddRoundedIcon />} onClick={addLink}>Adicionar contato</Button>
      </div>

      {[
        ["bases_legais","Bases legais (lista)"],
        ["finalidades","Principais finalidades (lista)"],
        ["direitos","Direitos do titular (lista)"],
        ["como_exercer_steps","Como exercer (passos em ordem)"],
      ].map(([k,label])=>(
        <Box key={k}>
          <Typography variant="subtitle2">{label}</Typography>
          {(v[k] || []).map((t,i)=>(
            <Box key={`${k}-${i}`} style={row}>
              <TextField value={t} onChange={(e)=>setSimple(k,i,e.target.value)} fullWidth />
              <IconButton onClick={()=>remSimple(k,i)}><DeleteOutlineRoundedIcon /></IconButton>
            </Box>
          ))}
          <Button startIcon={<AddRoundedIcon />} onClick={()=>addSimple(k)}>Adicionar item</Button>
        </Box>
      ))}

      <div>
        <Typography variant="subtitle2">Compartilhamento e operadores</Typography>
        <TextField
          label="Texto"
          value={v.compartilhamento || ""}
          onChange={(e)=>set({ compartilhamento: e.target.value })}
          fullWidth multiline minRows={3} sx={{ mt: 1 }}
        />
      </div>

      <div>
        <Typography variant="subtitle2">Segurança e retenção</Typography>
        <TextField
          label="Texto"
          value={v.seguranca_retencao || ""}
          onChange={(e)=>set({ seguranca_retencao: e.target.value })}
          fullWidth multiline minRows={3} sx={{ mt: 1 }}
        />
      </div>

      <div>
        <Typography variant="subtitle2">ANPD e atualizações</Typography>
        <TextField
          label="Texto"
          value={v.anpd || ""}
          onChange={(e)=>set({ anpd: e.target.value })}
          fullWidth multiline minRows={3} sx={{ mt: 1 }}
        />
      </div>

      <div>
        <Typography variant="subtitle2">Links de referência (opcional)</Typography>
        <Box sx={{ display:"grid", gridTemplateColumns:"repeat(2, 1fr)", gap: 8 }}>
          {/* Privacy */}
          <Box>
            <Typography variant="body2">Declaração de Privacidade</Typography>
            <Box sx={{ display:"grid", gridTemplateColumns:"2fr 3fr 1fr", gap: 8, mt: 1 }}>
              <TextField label="Rótulo" value={v.links_refs?.privacy?.label || ""} onChange={(e)=>set({ links_refs:{ ...v.links_refs, privacy:{ ...(v.links_refs?.privacy||{}), label:e.target.value } } })} />
              <TextField label="URL" value={v.links_refs?.privacy?.href || ""} onChange={(e)=>set({ links_refs:{ ...v.links_refs, privacy:{ ...(v.links_refs?.privacy||{}), href:e.target.value } } })} />
              <FormControl>
                <InputLabel>Target</InputLabel>
                <Select label="Target" value={v.links_refs?.privacy?.target || "_self"} onChange={(e)=>set({ links_refs:{ ...v.links_refs, privacy:{ ...(v.links_refs?.privacy||{}), target:e.target.value } } })}>
                  <MenuItem value="_self">_self</MenuItem>
                  <MenuItem value="_blank">_blank</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>

          {/* Cookies */}
          <Box>
            <Typography variant="body2">Política de Cookies</Typography>
            <Box sx={{ display:"grid", gridTemplateColumns:"2fr 3fr 1fr", gap: 8, mt: 1 }}>
              <TextField label="Rótulo" value={v.links_refs?.cookies?.label || ""} onChange={(e)=>set({ links_refs:{ ...v.links_refs, cookies:{ ...(v.links_refs?.cookies||{}), label:e.target.value } } })} />
              <TextField label="URL" value={v.links_refs?.cookies?.href || ""} onChange={(e)=>set({ links_refs:{ ...v.links_refs, cookies:{ ...(v.links_refs?.cookies||{}), href:e.target.value } } })} />
              <FormControl>
                <InputLabel>Target</InputLabel>
                <Select label="Target" value={v.links_refs?.cookies?.target || "_self"} onChange={(e)=>set({ links_refs:{ ...v.links_refs, cookies:{ ...(v.links_refs?.cookies||{}), target:e.target.value } } })}>
                  <MenuItem value="_self">_self</MenuItem>
                  <MenuItem value="_blank">_blank</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Box>
      </div>

      <div>
        <TextField
          label="Rodapé / Observação legal (opcional)"
          value={v.disclaimer || ""}
          onChange={(e)=>set({ disclaimer: e.target.value })}
          fullWidth multiline minRows={2}
        />
      </div>
    </Box>
  );
};

export default LgpdEditor;
